import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Form from 'components/Form/FormTwoColumns';
import { useStyles } from "./style";
import { Container, Paper } from '@material-ui/core';
import DialogLoadingMessage from 'components/LoadingMessage/index'
import BotonPersonalizado from 'components/BotonNormal'
import {functions} from 'constants/index';

export default function FormFirmaElectronica(props) {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const Cerrar = () => {
        props.closeModal()
        setLoading(false)
    }
    const [elements, setElements] = useState({
        password: { idelement: "password",  value:'', label: props.inputTitleProcess, pattern:"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@#$!¡:.;{}+=^~|%*¿?&/-])[A-Za-z\\d$@#$!¡:.;{}+=^~|%*¿?&/-]\\S{6,20}$", validators: ['required'], errorMessages:['Contraseña requerida'], isError:false, elementType:'password' },
    });

    const [buttonList,setButtonList]= React.useState({
        "process":{"label":props.buttonTitleProcess,"icon": props.buttonIconProcess,"callback":props.buttonProcess,"loading":false, disabled: false },   
        "cancel":{"label":props.buttonTitleCancel,"icon": props.buttonIconCancel,"callback":Cerrar, isCancel: true, IsButtonCancelar: true, "loading":false},
    });

    const process = () =>{
        let allGood = true;
        allGood = functions.checkIsEmptyWhenRequiredElement(
            elements,
            setElements
        );        
        if(allGood){
            return props.buttonProcess(elements.password.value)
        }
    }
  return (
    <Container maxWidth="md">
        <Grid container direction="row" justifyContent="center" alignItems="center" className={classes.root} spacing={2}>        
            <Grid item xs={12} >
                <Paper variant="outlined" className={classes.colorComponente}>
                    <Grid item xs={12} md={12} direction="row" justifyContent="center" alignItems="center" className={classes.rootContainer}>
                        <DialogLoadingMessage open={loading} title={props.titleLoading}/>
                        {
                            !props.esBotonPersonalizado ?(
                                <Form   
                                    elements= {elements}
                                    buttonList={buttonList}
                                />           
                            ):
                            <div >
                                <Form   
                                    elements= {elements}
                                />
                                <div className={classes.centrarBotonPersonalizado}>
                                    <BotonPersonalizado className={classes.centrarBotonPersonalizado} title={props.buttonTitleProcess} botonPersonalizado={true} function={process} icon={props.buttonIconProcess}/>
                                    <BotonPersonalizado className={classes.centrarBotonPersonalizado} title={props.buttonTitleCancel} botonPersonalizado={true} function={props.closeModal} icon={props.buttonIconCancel}/>
                                </div>           
                            </div>
                        }
                    </Grid>
                    <div className={classes.lineaDegradadaBottom}></div>
                </ Paper>
            </Grid>
        </Grid>                         
    </Container>
  );
}
